import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsTop() {
  const testimonials = [{
    initials: 'MG',
    name: 'Mariana G.',
    location: 'México DF',
    quote: 'Llevaba semanas intentando que ChatGPT me diera resultados útiles. Con el sistema del Tomo 2 lo logré en una tarde. El método del Doble Hemisferio cambió todo.'
  }, {
    initials: 'LP',
    name: 'Luis P.',
    location: 'Bogotá · Agencia de Marketing',
    quote: 'Los prompts del Bono 2 me ahorraron horas cada semana. Los uso para correos, reportes y contenido. Increíble lo que se logra con el prompt correcto.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    quote: 'Mis clientes ahora me preguntan cómo produzco tanto contenido tan rápido. La respuesta está en el Tomo 4 y el Bono 5. Vale cada centavo.'
  }];
  return <section className="py-16 px-4" data-id="element-313">
      <div className="max-w-6xl mx-auto" data-id="element-314">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-315">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-surface border border-border rounded-2xl p-6 hover:border-brand/30 transition-colors" data-id="element-316">
              <div className="flex items-center gap-4 mb-4" data-id="element-317">
                <div className="w-12 h-12 rounded-full bg-brand/10 text-brand flex items-center justify-center font-bold text-lg" data-id="element-318">
                  {t.initials}
                </div>
                <div data-id="element-319">
                  <div className="font-bold text-white" data-id="element-320">{t.name}</div>
                  <div className="text-sm text-muted" data-id="element-321">{t.location}</div>
                </div>
              </div>
              <div className="flex gap-1 mb-3" data-id="element-322">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-accent text-accent" data-id="element-323" />)}
              </div>
              <p className="text-gray-300 italic" data-id="element-324">"{t.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}